import axios from '../../http/axios/index.js'

export default {
  getAllAliados ({ commit }, item) {
    console.log('item', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getAllyAccounts', item,
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('Aliados ', response.data)

          if (response.data.v_code === 0) {
            console.log('Aliados length', response.data.allyAccountList.length)

            const lista = response.data.allyAccountList ? response.data.allyAccountList : []
            commit('SET_ALIADOS', lista)
            resolve(response)
          } else {
            reject(response.v_errm)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  insertOrReplaceAllyAccount ({ commit }, aliado) {
    return new Promise((resolve, reject) => {
      axios
        .post('/insertOrReplaceAllyAccount', aliado)
        .then(response => {
          if (response.data.v_code === 0) {
            commit('ID_ALIADO_MODIFICADO', response.data.account_id)
            resolve(response)
          } else {

            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteAliado ({ commit }, idAccount) {
    return new Promise((resolve, reject) => {
      axios
        .post('/deleteAllyAccount', {idAccount})
        .then(response => {
          if (response.data.v_code === 0) {
            commit('ID_ALIADO_MODIFICADO', response.data.account_id)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    }
    )
  },

  createAccountRequestRel ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/createAccountRequestRel',
          item,
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          if (response.data.nuOK === 0 && response.data.v_code === 0) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
